import { Box, Text, TextInputField } from "@pallet-hq/hegel"
import {
    CardCvcElement,
    CardExpiryElement,
    CardNumberElement,
} from "@stripe/react-stripe-js"
import { StripeElementInput } from "@pallet/components/inputs/StripeElementInput"

export const CreatePaymentMethodForm = () => (
    <Box display="flex" flexDirection="column" gridGap="small">
        <Text variant="uiLarge500">Payment information</Text>
        <TextInputField
            name="nameOnCard"
            label="Name on card"
            placeholder="Parker James"
            width="100%"
        />
        <StripeElementInput
            stripeElement={CardNumberElement}
            label="Card Number"
            width="100%"
        />
        <Box display="flex" gridGap="small">
            <StripeElementInput
                stripeElement={CardExpiryElement}
                label="Card Expiration"
                width="100%"
            />
            <StripeElementInput
                stripeElement={CardCvcElement}
                label="Card CVC"
                width="100%"
            />
            <TextInputField
                name="postalCode"
                label="Zip code"
                width="100%"
                placeholder="10012"
            />
        </Box>
        <Text variant="paragraphSmall" color="gray600" textAlign="center">
            This payment method will be used for recurring subscription
            payments. You can edit your payment methods by clicking Manage
            Billing.
        </Text>
    </Box>
)
